/*
 * Copyright (c) Nexign, JSC, 2022-2025.
 */
/**
 *
 *
 * @author Yakov Gushchin
 * @author Nikolay Sviridov
 * @version 1.36.0
 * @since 1.19.0
 */

import { useDispatch, useSelector } from 'react-redux';

import { getIsFastActionPage } from '@/main/components/Table/utils/tableUtils';

import { tableBasketCheckboxUrlSelector } from '../selectors';
import { setCheckbox, setFastActionCheckbox } from '../slice';
import { tableApi } from '../store';
import { ITableBasketItem } from '../types';

export const useTableCheckboxApi = () => {
    const dispatch = useDispatch();

    /* Selectors */
    const checkboxUrl = useSelector(tableBasketCheckboxUrlSelector);

    /* API */
    const [setCheckboxApi] = tableApi.endpoints.check.useMutation();

    const isFastActionPage = getIsFastActionPage();

    return {
        /* Изменение состояния checkbox */
        check: (value: boolean, item?: ITableBasketItem) => {
            if (checkboxUrl && !isFastActionPage) {
                setCheckboxApi({
                    url: checkboxUrl,
                    items: item ? [item] : undefined,
                    value,
                }).then(() => {
                    dispatch(setCheckbox({ id: item?.id, checked: value }));
                });
            } else {
                dispatch(setFastActionCheckbox({ id: item?.id, checked: value }));
            }
        },
    };
};

